import { action, thunk } from 'easy-peasy';
import { getAccount, getAccounts } from '../services/Account';

const AccountModel = {
  account: {},
  accounts: [],

  showAccount: action((state, account) => {
    state.account = account;
  }),

  showAccounts: action((state, accounts) => {
    state.accounts = accounts || [];
  }),

  getAccounts: thunk(async (actions) => {
    let accounts = await getAccounts();
    actions.showAccounts(accounts);
  }),

  getAccount: thunk(async (actions) => {
    let account = await getAccount();
    actions.showAccount(account);
  }),
};

export default AccountModel;
